import { Link } from "react-router-dom";
import { X, Plus, Minus, ShoppingBag } from "lucide-react";
import { useStore } from "@/lib/store";
import { formatINR } from "@/lib/api";

export const CartDrawer = () => {
  const { cartOpen, setCartOpen, cart, updateQty, removeFromCart, cartSubtotal } = useStore();
  return (
    <>
      <div
        className={`fixed inset-0 bg-black/60 backdrop-blur-sm z-50 transition-opacity ${cartOpen ? "opacity-100" : "opacity-0 pointer-events-none"}`}
        onClick={() => setCartOpen(false)}
      />
      <aside
        data-testid="cart-drawer"
        className={`fixed top-0 right-0 h-full w-full sm:w-[440px] bg-[#1C130E] border-l border-[#D4AF37]/20 z-50 transform transition-transform duration-500 flex flex-col ${cartOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="flex items-center justify-between p-6 border-b border-[#D4AF37]/15">
          <div>
            <div className="eyebrow">Your Aura</div>
            <div className="font-serif-luxe text-2xl text-[#FAF8F5] mt-1">Shopping Bag</div>
          </div>
          <button data-testid="close-cart" onClick={() => setCartOpen(false)} className="text-[#FAF8F5] hover:text-[#D4AF37]"><X size={22}/></button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {cart.length === 0 ? (
            <div className="text-center py-20">
              <ShoppingBag className="mx-auto text-[#D4AF37]/60" size={40}/>
              <div className="mt-4 text-[#C2B29F]">Your bag awaits a treasure.</div>
              <Link to="/shop" onClick={() => setCartOpen(false)} className="btn-outline-gold mt-6 inline-flex">Shop Jewellery</Link>
            </div>
          ) : (
            <ul className="space-y-6">
              {cart.map((i) => (
                <li key={i.product_id} data-testid={`cart-item-${i.product_id}`} className="flex gap-4">
                  <Link to={`/product/${i.slug}`} onClick={() => setCartOpen(false)} className="block w-24 h-24 bg-[#2A1D17] overflow-hidden shrink-0">
                    <img src={i.image} alt={i.name} className="w-full h-full object-cover"/>
                  </Link>
                  <div className="flex-1">
                    <Link to={`/product/${i.slug}`} onClick={() => setCartOpen(false)} className="text-sm text-[#FAF8F5] hover:text-[#D4AF37]">{i.name}</Link>
                    <div className="text-sm text-[#D4AF37] mt-1">{formatINR(i.price)}</div>
                    <div className="mt-3 flex items-center gap-2">
                      <button onClick={() => updateQty(i.product_id, i.quantity - 1)} className="w-7 h-7 border border-[#D4AF37]/30 flex items-center justify-center text-[#FAF8F5] hover:border-[#D4AF37]"><Minus size={12}/></button>
                      <span className="text-sm text-[#FAF8F5] w-6 text-center">{i.quantity}</span>
                      <button onClick={() => updateQty(i.product_id, i.quantity + 1)} className="w-7 h-7 border border-[#D4AF37]/30 flex items-center justify-center text-[#FAF8F5] hover:border-[#D4AF37]"><Plus size={12}/></button>
                      <button data-testid={`remove-${i.product_id}`} onClick={() => removeFromCart(i.product_id)} className="ml-auto text-xs text-[#C2B29F] hover:text-[#D4AF37] uppercase tracking-widest">Remove</button>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>

        {cart.length > 0 && (
          <div className="p-6 border-t border-[#D4AF37]/15">
            <div className="flex justify-between text-sm text-[#C2B29F] mb-1"><span>Subtotal</span><span className="text-[#FAF8F5]">{formatINR(cartSubtotal)}</span></div>
            <div className="flex justify-between text-sm text-[#C2B29F] mb-4"><span>Insured Shipping</span><span className="text-[#D4AF37]">Complimentary</span></div>
            <Link to="/checkout" data-testid="checkout-btn" onClick={() => setCartOpen(false)} className="btn-gold w-full">Proceed to Checkout</Link>
            <div className="text-[10px] text-center text-[#C2B29F] mt-3 tracking-[0.24em] uppercase">Certified · Hallmarked · Insured</div>
          </div>
        )}
      </aside>
    </>
  );
};
